import React from "react";

const TableIcon = () => {
    return (
        <svg width="16" height="16" className="me-2" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M3.2 14L4.4 11.1875C4.52 10.9 4.71333 10.6719 4.98 10.5031C5.24667 10.3344 5.54667 10.25 5.88 10.25H7.4V7.23125C5.28 7.16875 3.51667 6.8875 2.11 6.3875C0.703333 5.8875 0 5.3 0 4.625C0 3.9 0.78 3.28125 2.34 2.76875C3.9 2.25625 5.78667 2 8 2C10.2133 2 12.1 2.25625 13.66 2.76875C15.22 3.28125 16 3.9 16 4.625C16 5.3 15.2967 5.8875 13.89 6.3875C12.4833 6.8875 10.72 7.16875 8.6 7.23125V10.25H10.12C10.44 10.25 10.7367 10.3344 11.01 10.5031C11.2833 10.6719 11.48 10.9 11.6 11.1875L12.8 14H11.6L10.5 11.375H5.52L4.4 14H3.2ZM8 6.125C9.44 6.125 10.7867 5.9875 12.04 5.7125C13.2933 5.4375 14.2467 5.075 14.9 4.625C14.2467 4.175 13.2933 3.8125 12.04 3.5375C10.7867 3.2625 9.44 3.125 8 3.125C6.56 3.125 5.21333 3.2625 3.96 3.5375C2.70667 3.8125 1.75333 4.175 1.1 4.625C1.75333 5.075 2.70667 5.4375 3.96 5.7125C5.21333 5.9875 6.56 6.125 8 6.125Z"
                fill="#1F3354"
            />
        </svg>
    );
};
export default TableIcon;
